module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  actions: 'Actions',
  filter: 'Filter for company',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postal code',
  createCompany: 'Create company',
  editCompany: 'Edit company',
  customOption: 'Custom option',
  search: 'Search',
  export: 'Export',
  available: 'Available',
  inuse: 'In Use',
  finishing: 'Finishing',
  reserved: 'Reserved',
  idle: 'Idle',
  size: 'Size',
  style: 'Style',
  variant: 'Variant',
  options: 'Options',
  orderCode: 'Order code',
  source: 'Source',
  discount: 'Discount',
  discountTotal: 'Discount total',
  percentDiscount: 'Discount in %',
  terminals: 'Terminals',
  loadingTerminals: 'Loading terminals...',
  payments: 'Payments',
  from: 'From',
  to: 'To',
  training: 'Training',
  notes: 'Notes ...',
  driverNotes: 'Driver notes ...',
  serviceCharges: 'Service charges',
  postalCode: 'Postal code',
  line1: 'Line 1',
  line2: 'Line 2',
  line3: 'Line 3',
  line4: 'Line 4',
  action: 'Action',
  serviceCharge: 'Service charge',
  deliveryCharge: 'Delivery charge',
  invoice: 'Invoice',
  invoiceSearch: 'Invoice search',
  receiptSearch: 'Receipt search',
  invoiceNumber: 'Invoice Number',
  receiptNo: 'Receipt Number',
  receiptTypes: 'Receipt Types',
  startReceipt: 'Start Receipt',
  endReceipt: 'End Receipt',
  monthlyReceipt: 'Monthly Receipt',
  yearlyReceipt: 'Yearly Receipt',
  nullReceipt: 'Null Receipt',
  regularReceipt: 'Regular Receipt',
  cancelReceipt: 'Cancel Receipt',
  collectionReceipt: 'Collection Receipt',
  allNone: 'All/None',
  first: 'First name',
  last: 'Last name',
  manufacturer: 'Manufacturer',
  model: 'Model',
  default: 'Default',
  registeredOn: 'Registered on',
  lastModifiedOn: 'Last modified on',
  createdOn: 'Created on',
  modifiedOn: 'Modified on',
  cashRegisterName: 'Cash Register Name',
  lines: 'Lines',
  collect: 'Collect',
  reportLines: 'Report lines',
  balances: 'Balances',
  previousSession: 'Previous Session Totals',
  currentSession: 'Current Session Totals',
  previousOrder: 'Previous order',
  hour: 'Hour',
  minute: 'Minute',
  beforeDiscount: 'Total before discount',
  mandatory: 'Mandatory',
  loadingPayments: 'Loading payments...',
  transactions: 'Transactions',
  response: 'Response',
  loadingTransactions: 'Loading transactions...',
  notifications: 'Notifications',
  text: 'Text',
  themes: 'Themes',
  unpaidOrders: 'Unpaid orders',
  numberOfPayments: 'Number of payments',
  details: 'Details',
  tipAmount: 'Tip amount',
  dcTaxRate: 'Delivery Charges Tax Rate',
  orderId: 'Order ID',
  download: 'Download',
  host: 'Host',
  changedHardware: 'Changed hardware?',
  swithcCode: 'Table switch code',
  instance: 'Instance',
  backendversion: 'Backend version',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  noUser: 'No user',
  regularInvoices: 'Regular invoices',
  cancellationInvoices: 'Cancellation invoices',
  printers: 'Printers',
  printJobs: 'PrintJobs',
  changePassword: 'Change password',
  dbOptimization: 'DB optimization',
  payment: 'Payment',
  system: 'System',
  dataExport: 'Data Export',
  depReceipts: 'DEP and receipts',
  depAll: 'All logs',
  cashAmount: 'Cash amount received',
  changeGiven: 'Change given',
  orderType: 'Order type',
  tip: 'Tip',
  receiptNumber: 'Receipt number',
  nonTrainingPayedOrders: 'Regular payed orders',
  nonTrainingUnpaidOrders: 'Regular unpayed orders',
  nonTrainingServiceCharges: 'Regular service charges',
  trainingPayedOrders: 'Training payed orders',
  trainingUnpaidOrders: 'Training unpayed orders',
  trainingServiceCharges: 'Training service charges',
  vatPrint: 'VAT Print',
  monthlyTaxReport: 'Monthly Tax Report',
  generatedOn: 'Generated on',
  regularTotalAmount: 'Regular Total Amount',
  amountOfOrders: 'Amount of orders',
  amountOfInvoices: 'Amount of invoices',
  cancellationTotalAmount: 'Cancellation Total Amount',
  detailsPerDay: 'Details per day',
  created: 'Created',
  printed: 'Printed',
  prepared: 'Prepared',
  inDelivery: 'In Delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  notCollected: 'Not Collected',
  collected: 'Collected',
  disputed: 'Disputed',
  regular: 'Regular',
  cardName: 'Card Name',
  cardId: 'Card ID',
  register: 'Register',
  externalId: 'External card ID',
  walletId: 'Wallet ID',
  balance: 'Balance',
  cardData: 'Card Data',
  getCardBookings: 'Get Card Bookings',
  noBookings: 'There is no Bookings for this Card in this time frame.',
  cardBookings: 'Card Bookings',
  amount: 'Amount',
  expired: 'Expired',
  bookingId: 'Booking ID',
  bookingType: 'Booking type',
  noWallets: 'No wallets found for this contact.',
  wallets: 'Wallets',
  walletName: 'Wallet',
  reservedAmount: 'Available amount',
  walletDetails: 'Wallet Details',
  enterGalaxyCard: 'Enter Galaxy Card',
  number: 'No',
  mode: 'Mode',
  dark: 'Dark',
  simpleOrdering: 'Simple Ordering',
  fontSizes: 'Font Sizes',
  theme: 'Themes',
  useLastPaymentMethod: 'Use previous payment method',
  amountOfPersons: 'Amount of persons',
  refreshCompanySettings: 'Refresh Company Settings',
  refreshCatalog: 'Refresh Catalog',
  reason: 'Please enter a deactivation reason',
  deactivationWarning: 'ATTENTION: once deactivated, the card is no longer usable. This action can not be undone.',
  none: 'None',
  discounts: 'Discounts',
  clickToRemove: 'Click on discount button to remove it',
  moon: 'Moon',
  webshop: 'Webshop',
  mostSoldItem: 'Most sold item count',
  mostCanceledItem: 'Most canceled item count',
  monthYear: 'Month / Year',
  soldCount: 'Sold count',
  canceledCount: 'Canceled count',
  moonItemUsageSummary: 'Moon Item Usage Summary',
  webshopItemUsageSummary: 'Webshop Item Usage Summary',
  catalogId: 'Catalog Item ID',
  dailyitemusage: 'Daily',
  monthlyitemusage: 'Monthly',
  noCancelation: 'No data available.',
  servicecharge: 'Service charge',
  deliverycharge: 'Delivery charge',
  itemprice: 'Item',
  totalSoldAmount: 'Sold amount',
  totalCancelledAmount: 'Cancelled amount',
  byVat: 'By VAT rate',
  byTaxCategory: 'By tax category',
  byPaymentType: 'By payment type',
  total: 'Total',
  selectAddress: 'Select Address',
  quantity: 'Quantity',
  comment: 'Comment',
  deliveryCharges: 'Delivery charges',
  latitude: 'Latitude',
  longitude: 'Longitude',
  price: 'Price',
  deliveryType: 'Delivery type',
  selectHours: 'Select hours',
  selectMinute: 'Select minutes',
  totalAmount: 'Total Amount',
  deliveryMethod: 'Delivery method',
  change: 'Change',
  contactInfo: 'Contact information',
  paymentMethod: 'Payment method',
  voucher: 'Voucher',
  time: 'time',
  startTyping: 'Start typing to Search',
  asSoon: 'As soon as possible',
  address: 'Address',
  line3AT: 'Staircase/apartment/Address details',
  line2AT: 'House number',
  line1AT: 'Street',
  chat: 'Chat',
  allergens: 'Allergens',
  showAllergens: 'Show allergen(s)',
  vatRate: 'VAT rate',
  firstName: 'First Name',
  lastName: 'Last Name',
  tableName: 'Table Name',
  dateTime: 'Date and Time',
  customerTrackingTitle1: 'Erhebung von Kontaktdaten von Gästen in der Gastronomie',
  customerTrackingTitle2: 'gemäß der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19. Die Eintragung erfolgt durch die Kundin/den Kunden:',
  customerDesc: 'Datenschutzrechtliche Information nach Art. 13 DSGVO:\n' +
      'Zweck und Rechtsgrundlagen der Verarbeitung:\n' +
      'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' +
      'Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen natürlichen Person). § 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020\n' +
      'Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19\n' +
      'Verantwortlicher für die Verarbeitung der erhobenen personenbezogenen Daten $partnerCompanyName, $partnerPostalAddress, an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden können.\n\n' +
      'Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empfänger weitergeleitet:\n' +
      'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' +
      'Empfänger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.\n' +
      'Hinweise\n' +
      'Ihre personenbezogenen Daten werden gem. § 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19 4 Wochen nach ihrer Aufnahme gelöscht.\n' +
      'Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.\n' +
      'Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtmäßig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der Österreichischen Datenschutzbehörde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at',
  visits: 'Visits',
  delete: 'Delete',
  save: 'Save',
  table: 'Table',
  deliveryOn: 'Delivery on',
  ordersSearch: 'Orders Search',
  blacklist: 'Blacklist',
  all: 'All',
};



// WEBPACK FOOTER //
// ./src/lang/en/labels.js